import React from 'react'
import {} from 'prop-types'
import cx from 'classnames'

const CLASS_ROOT = 'article'

const propTypes = {}

const Article = ({ className, children, ...other }) => {
  const classes = cx(CLASS_ROOT, className)

  return (
    <article className={classes} {...other}>
      {children}
    </article>
  )
}

Article.propTypes = propTypes

export default Article
